import { PASSENGER_FLOW_WEEKEND, PASSENGER_FLOW_MODE, PASSENGER_FLOW_MODE_MAP, PASSENGER_FLOW_SPOTS, PASSENGER_FLOW_WEEKDAY, PASSENGER_FLOW_SPOT_LIST } from '@/common/components/business/DynamicComponent/components/PassengerFlow/config';
import SpotFlowCard from '@/common/components/business/DynamicComponent/components/PassengerFlow/SpotFlowCard';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import { Col } from 'antd';
import { FC } from 'react';
import styles from '../index.module.less';
import { isArray, isUndef } from '@lhb/func';

/**
 * @Description 客流计数详情
 */
const PassengerFlowCountingDetail:FC<{
  textValue: string | undefined;
}> = ({
  textValue
}) => {
  return (
    <>
      <Col span={12}>
        <V2DetailItem
          label={PASSENGER_FLOW_MODE.label}
          value={textValue?.[PASSENGER_FLOW_MODE.key] ? (textValue?.[PASSENGER_FLOW_MODE.key] === PASSENGER_FLOW_MODE_MAP.DEVICE ? '设备采集' : '人工采集') : '-'}/>
      </Col>
      {textValue?.[PASSENGER_FLOW_MODE.key] === PASSENGER_FLOW_MODE_MAP.DEVICE
        ? <>
          <Col span={12}>
            <V2DetailItem
              label={PASSENGER_FLOW_SPOTS.label}
              value={textValue?.[PASSENGER_FLOW_SPOT_LIST]?.map((item) => item.name)?.join('、')}/>
          </Col>
          <Col span={24}>
            <div className={styles.spotFlowList}>
              {isArray(textValue?.[PASSENGER_FLOW_SPOT_LIST]) && textValue?.[PASSENGER_FLOW_SPOT_LIST]?.map((item, index) => (
                <SpotFlowCard key={index} itemData={item}/>
              ))}
            </div>
          </Col>
        </>
        : <></>}
      <Col span={12}>
        <V2DetailItem
          label={PASSENGER_FLOW_WEEKDAY.label}
          value={!isUndef(textValue?.[PASSENGER_FLOW_WEEKDAY.key]) ? textValue?.[PASSENGER_FLOW_WEEKDAY.key] + '人' : '-'}/>
      </Col>
      <Col span={12}>
        <V2DetailItem
          label={PASSENGER_FLOW_WEEKEND.label}
          value={!isUndef(textValue?.[PASSENGER_FLOW_WEEKEND.key]) ? textValue?.[PASSENGER_FLOW_WEEKEND.key] + '人' : '-'}/>
      </Col>
    </>
  );
};

export default PassengerFlowCountingDetail;
